module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YtDAyp/tc-custom/9781646562435.jpg?1723408608289",
      "alt": "This image is the cover for the book The Portal's Gift"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Portal's Gift\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The most famous astronaut on earth discovers hyperspace has interesting consequences when he is marooned with his alien shipmate."), _c('br'), _c('br'), _vm._v("When Earth joins forces with the friendly Teneran aliens to gain access to their hyperspace drive, Josh is the first human to copilot with a Teneran commander. On the "), _c('i', [_vm._v("Marco Polo")]), _vm._v(", a Terran ship equipped with the alien drive, he and the enigmatic Teneran Paris explore distant worlds no astronaut from earth could have visited without help from the aliens."), _c('br'), _c('br'), _vm._v("Not until a blinding sandstorm maroons Josh and Paris on a desolate planet does Josh realize the implications of the Teneran drive. He finds himself unaccountably attracted to Paris. Will his travels through the portals of space change his life forever?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carol Holland March\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0